const API_KEY = "123e4567-e89b-12d3-a456-426614174000";
const BASE_URL = "https://did.myearth.id/v2";
const STORE_URL = "https://procreddb.myearth.id/api/vcnew/store";
const GET_ALL_VCS_URL = "https://procreddb.myearth.id/api/vcnew/";
const ISSUER_DID = "did:earthid:mainnet:9xEfr5h8HMMPCpD6q7NnGAMoG9wvUxsKVfPYoQT4mn8Q:0.0.8676505";

/**
 * Generic API call helper
 */
async function makeApiCall(url, method, headers, body = null) {
  const options = { method, headers };
  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);
    const text = await response.text();
    const data = JSON.parse(text);
    if (!response.ok) throw new Error(data?.message || 'API call failed');
    return data;
  } catch (error) {
    console.error(`❌ API error: ${url}`, error.message);
    throw error;
  }
}

/**
 * Generate Key Pair
 */
export async function generateKeyPair() {
  return await makeApiCall(`${BASE_URL}/generate-keypair`, "GET", {
    "Accept": "application/json",
    "x-api-key": API_KEY,
  });
}

/**
 * Create DID from public key
 */
export async function createDid(publicKey) {
  return await makeApiCall(`${BASE_URL}/dids`, "POST", {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "x-api-key": API_KEY,
  }, {
    publicKey,
    method: "earthid"
  });
}


/**
 * Create VC Template
 */
export async function createVcTemplate({ name, attributes, type }) {
  const payload = {
    templateName: name,
    description: `${type} Credential VC`,
    issuer: ISSUER_DID,
    attributes: attributes.map(attr => ({
      attributeName: attr.key,
      type: "alphanumeric", // or infer based on logic if needed
      description: attr.label || attr.key,
      required: true
    })),
    expiration: {
      value: "1",
      unit: "Year"
    }
  };

  return await makeApiCall(`${BASE_URL}/vc-templates`, "POST", {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "x-api-key": API_KEY
  }, payload);
}


/**
 * Issue Professional Certificate VC
 */
export async function issueCredential({ userDid, ...formData }) {
  // Build dynamic credentialSubject from formData
  const credentialSubject = {
    ...formData  // dynamically include all submitted fields
  };

  const vcPayload = {
    vcTemplate: formData.template || "DefaultTemplate",
    issuerDid: ISSUER_DID,
    userDid,
    isEncrypted: false,
    credentialSubject,
    validity: "5"
  };

  return await makeApiCall(`${BASE_URL}/credentials`, "POST", {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "x-api-key": API_KEY,
  }, vcPayload);
}


/**
 * Store VC
 */
export async function storeCredential(subjectName, vcResponse) {
  return await makeApiCall(STORE_URL, "POST", {
    "Content-Type": "application/json",
    "Accept": "application/json",
  }, {
    company: subjectName,
    type: "CertificateVC",
    issuerDID: ISSUER_DID,
    vc: vcResponse
  });
}


export async function getAllVCs(userId) {
  try {
    const response = await fetch(`https://procreddb.myearth.id/api/vcnew/company/${userId}`, {
      method: "GET",
      redirect: "follow"
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch VCs: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("✅ VCs for user:", userId, data);
    return data;
  } catch (error) {
    console.error("❌ Error fetching VCs for user:", userId, error);
    return null;
  }
}


export async function getVCById(vcID) {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({ vcID }),
    redirect: "follow",
  };

  try {
    const response = await fetch("https://procreddb.myearth.id/api/vcnew/show", requestOptions);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("❌ Error fetching VC by ID:", error);
    return null;
  }
}
